import { forwardRef } from 'react';
import { Input, InputProps } from './Input';

interface PasswordInputProps extends Omit<InputProps, 'type'> {
  showPasswordHint?: boolean;
  loading?: boolean;
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ showPasswordHint = false, variant = 'secondary', loading = false, ...props }, ref) => {
    if (loading) {
      return (
        <div>
          <Input loading={true} {...props} />
          {showPasswordHint && (
            <div className="animate-pulse bg-primary-100 dark:bg-primary-800 rounded h-3 w-48 mt-1" />
          )}
        </div>
      );
    }

    return (
      <div>
        <Input
          ref={ref}
          type="password"
          variant={variant}
          loading={loading}
          {...props}
        />
        {showPasswordHint && !props.error && (
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Deve ter pelo menos 6 caracteres
          </p>
        )}
      </div>
    );
  }
);

PasswordInput.displayName = 'PasswordInput';